import lineColumn from "line-column"

// Liquid will give string errors like so:
// Liquid error: Syntax error, expected: ., [, |, :, with, ,, limit, offset, reversed, .., ), }}, +, -, *, /, %, ==, >, <, >=, <=, <>, !=, contains, and, or, %}, ] at line:1, col:18
// We are parsing the string and looking for `line:1, col:18` to identify where the issue is and then enhance the error message with a hint
const addHintToLiquidErrorString = ({ message, templateSource } = {}) => {
	if (!message) return ""
	if (!templateSource) return { message }

	let line = message?.match(/line:\d*/)?.[0]?.split(":")?.[1]
	let col = message?.match(/col:\d*/)?.[0]?.split(":")?.[1]

	// If no line or col, return just message
	if (!line || !col) return { message }

	line = Number(line)
	col = Number(col)

	const templateStr = templateSource?.replace(/\u21b5/g, "\n") // replace "enter" from the string with \n so that lineColumn works properly
	const index = lineColumn(templateStr).toIndex({ line: line, col: col })
	const faultyLiquid = templateStr.slice(index - 30 > -1 ? index - 30 : 0, index) + "❌" + templateStr.slice(index, index + 30)

	// Output
	const output = { message, hint: faultyLiquid }
	return output
}

export { addHintToLiquidErrorString }
